export const TIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='44.926'
		height='44.759'
		viewBox='0 0 44.926 44.759'>
		<defs>
			<linearGradient
				id='linear-gradient'
				x1='0.5'
				x2='0.5'
				y2='1'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stop-color='#ff3067' />
				<stop offset='1' stop-color='#a5119f' />
			</linearGradient>
		</defs>
		<g id='text-box' transform='translate(0 -0.952)'>
			<g
				id='Group_4742'
				data-name='Group 4742'
				transform='translate(2.449 3.401)'>
				<path
					id='Path_3540'
					data-name='Path 3540'
					d='M29.225,61.24a1.316,1.316,0,0,1-1.316-1.316V30.178a1.316,1.316,0,0,1,1.316-1.316H58.971a1.316,1.316,0,0,1,0,2.632H30.541v28.43A1.316,1.316,0,0,1,29.225,61.24Z'
					transform='translate(-27.909 -28.862)'
					fill='#dbd8e4'
				/>
			</g>
			<g
				id='Group_4744'
				data-name='Group 4744'
				transform='translate(4.887 5.742)'>
				<path
					id='Path_3542'
					data-name='Path 3542'
					d='M63.011,454.854h-6a1.316,1.316,0,0,0,0,2.632h6a1.316,1.316,0,0,0,0-2.632Z'
					transform='translate(-55.693 -419.816)'
					fill='#dbd8e4'
				/>
				<path
					id='Path_3543'
					data-name='Path 3543'
					d='M218.882,454.854h-4.96a1.316,1.316,0,0,0,0,2.632h4.96a1.316,1.316,0,0,0,0-2.632Z'
					transform='translate(-198.837 -419.816)'
					fill='#dbd8e4'
				/>
				<g id='Group_4743' data-name='Group 4743' transform='translate(26.495)'>
					<path
						id='Path_3544'
						data-name='Path 3544'
						d='M364.956,454.854h-6a1.316,1.316,0,1,0,0,2.632h6a1.316,1.316,0,1,0,0-2.632Z'
						transform='translate(-357.638 -419.816)'
						fill='#dbd8e4'
					/>
					<path
						id='Path_3545'
						data-name='Path 3545'
						d='M454.708,55.546a1.316,1.316,0,0,0-1.316,1.316v6a1.316,1.316,0,0,0,2.632,0v-6A1.316,1.316,0,0,0,454.708,55.546Z'
						transform='translate(-444.99 -55.546)'
						fill='#dbd8e4'
					/>
					<path
						id='Path_3546'
						data-name='Path 3546'
						d='M454.708,212.457a1.316,1.316,0,0,0-1.316,1.316v4.96a1.316,1.316,0,0,0,2.632,0v-4.96A1.316,1.316,0,0,0,454.708,212.457Z'
						transform='translate(-444.99 -198.689)'
						fill='#dbd8e4'
					/>
					<path
						id='Path_3547'
						data-name='Path 3547'
						d='M454.708,357.49a1.316,1.316,0,0,0-1.316,1.316v6a1.316,1.316,0,0,0,2.632,0v-6A1.316,1.316,0,0,0,454.708,357.49Z'
						transform='translate(-444.99 -330.995)'
						fill='#dbd8e4'
					/>
				</g>
			</g>
			<path
				id='Path_3548'
				data-name='Path 3548'
				d='M133.487,106.156H110.343a1.316,1.316,0,0,0-1.316,1.316v11.2a1.316,1.316,0,0,0,2.33.839l3.683-4.451h2.308v12.034l-2.31,3.462a1.316,1.316,0,0,0,1.095,2.047H127.7a1.316,1.316,0,0,0,1.095-2.047l-2.31-3.462V115.061h2.308l3.683,4.451a1.316,1.316,0,0,0,2.33-.839v-11.2A1.317,1.317,0,0,0,133.487,106.156Z'
				transform='translate(-99.46 -95.973)'
				fill='url(#linear-gradient)'
			/>
			<path
				id='Path_3549'
				data-name='Path 3549'
				d='M6.214.952h-4.9A1.316,1.316,0,0,0,0,2.268v4.9A1.316,1.316,0,0,0,1.316,8.482h4.9A1.316,1.316,0,0,0,7.53,7.166v-4.9A1.316,1.316,0,0,0,6.214.952Z'
				fill='#3b2a82'
			/>
			<path
				id='Path_3550'
				data-name='Path 3550'
				d='M6.214,425.228h-4.9A1.316,1.316,0,0,0,0,426.544v4.9a1.316,1.316,0,0,0,1.316,1.316h4.9a1.316,1.316,0,0,0,1.316-1.316v-4.9A1.316,1.316,0,0,0,6.214,425.228Z'
				transform='translate(0 -387.047)'
				fill='#3b2a82'
			/>
			<path
				id='Path_3551'
				data-name='Path 3551'
				d='M432.4.952h-4.9a1.316,1.316,0,0,0-1.316,1.316v4.9A1.316,1.316,0,0,0,427.5,8.482h4.9a1.316,1.316,0,0,0,1.316-1.316v-4.9A1.316,1.316,0,0,0,432.4.952Z'
				transform='translate(-388.785)'
				fill='#3b2a82'
			/>
			<path
				id='Path_3552'
				data-name='Path 3552'
				d='M432.4,425.228h-4.9a1.316,1.316,0,0,0-1.316,1.316v4.9a1.316,1.316,0,0,0,1.316,1.316h4.9a1.316,1.316,0,0,0,1.316-1.316v-4.9A1.316,1.316,0,0,0,432.4,425.228Z'
				transform='translate(-388.785 -387.047)'
				fill='#3b2a82'
			/>
		</g>
	</svg>
)

export const EmptyAlbumIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='83.412'
		height='83.412'
		viewBox='0 0 83.412 83.412'>
		<g id='Group_4702' data-name='Group 4702' transform='translate(-71.265)'>
			<g id='image' transform='translate(71.265 0)'>
				<g id='Group_4472' data-name='Group 4472' transform='translate(0 0)'>
					<g id='Group_4471' data-name='Group 4471'>
						<path
							id='Path_3372'
							data-name='Path 3372'
							d='M75.592,0H7.82A7.82,7.82,0,0,0,0,7.82V75.592a7.82,7.82,0,0,0,7.82,7.82H75.592a7.82,7.82,0,0,0,7.82-7.82V7.82A7.82,7.82,0,0,0,75.592,0ZM78.2,75.592A2.606,2.606,0,0,1,75.592,78.2H7.82a2.607,2.607,0,0,1-2.607-2.607V7.82A2.607,2.607,0,0,1,7.82,5.213H75.592A2.607,2.607,0,0,1,78.2,7.82Z'
							transform='translate(0 0)'
							fill='#fff'
						/>
						<path
							id='Path_3373'
							data-name='Path 3373'
							d='M123.745,246.092a2.606,2.606,0,0,0-3.675,0l-6,6L102.892,240.9a2.607,2.607,0,0,0-3.675,0L80.97,259.151a2.607,2.607,0,0,0,1.825,4.431h52.133a2.607,2.607,0,0,0,1.851-4.457Z'
							transform='translate(-67.155 -201.024)'
							fill='#fff'
						/>
						<ellipse
							id='Ellipse_2'
							data-name='Ellipse 2'
							cx='7.146'
							cy='6.9'
							rx='7.146'
							ry='6.9'
							transform='translate(41.796 23.051)'
							fill='#fff'
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
)
